import type { LabelPrintBatchStatus } from "@shared/types";

export interface BatchStatusDisplay {
  badgeClassName: string;
  labelKey?: LabelPrintBatchStatus | "PartiallyFailed";
  label: string;
}

export const getBatchStatusDisplay = (status?: LabelPrintBatchStatus | "PartiallyFailed" | (string & {})): BatchStatusDisplay => {
  switch (status) {
    case "Completed":
      return {
        labelKey: "Completed",
        label: "Completed",
        badgeClassName: "bg-green-100 text-green-700 hover:bg-green-200 dark:bg-green-950 dark:text-green-400",
      };
    case "Processing":
      return {
        labelKey: "Processing",
        label: "Processing",
        badgeClassName: "bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-950 dark:text-blue-400",
      };
    case "Failed-for-Retry":
      return {
        labelKey: "Failed-for-Retry",
        label: "Failed for Retry",
        badgeClassName: "bg-amber-100 text-amber-700 hover:bg-amber-200 dark:bg-amber-950 dark:text-amber-400",
      };
    case "PartiallyFailed":
      return {
        labelKey: "PartiallyFailed",
        label: "Partially Failed",
        badgeClassName: "bg-amber-100 text-amber-700 hover:bg-amber-200 dark:bg-amber-950 dark:text-amber-400",
      };
    case "Failed":
      return {
        labelKey: "Failed",
        label: "Failed",
        badgeClassName: "bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-950 dark:text-red-400",
      };
    default:
      return {
        label: status ?? "Unknown",
        badgeClassName: "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-300",
      };
  }
};
